<script setup>
const props = defineProps({ item: Object });
const { t } = useI18n();

const label = computed(() =>
  props.item?.headerKey ? t(props.item.headerKey) : props.item?.header || ''
);
</script>

<template>
  <div class="nav-section">
    <div class="nav-section__line" aria-hidden="true" />
    <v-list-subheader class="nav-section__label">
      {{ label }}
    </v-list-subheader>
  </div>
</template>
